import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Customer, CustomerClient, Address } from 'src/shared/api';
import { FormConfig } from 'src/shared/form-models/form-cva.component';
import { exhaustMap } from 'rxjs/operators';

type AddCustomer = Pick<
	Customer,
	keyof {
		id: number;
		companyName: string;
		billingEmail: string;
		address: Address;
	}
>;

const addCustomerFormConfig: FormConfig<AddCustomer> = {
	id: [0],
	companyName: ['', [Validators.required]],
	billingEmail: ['', [Validators.required, Validators.email]],
	address: ['', [Validators.required]],
};

@Component({
	selector: 'rpfsa-add-customer-dialog',
	templateUrl: './add-customer-dialog.component.html',
})
export class AddCustomerDialogComponent implements OnInit {
	form = this.fb.group(addCustomerFormConfig) as FormGroup;

	constructor(
		private readonly fb: FormBuilder,
		private readonly customerClient: CustomerClient,
		private addCustomerDialogComponent: MatDialogRef<
			AddCustomerDialogComponent
		>,
		@Inject(MAT_DIALOG_DATA) private companyName: string
	) {}

	ngOnInit() {
		if (this.companyName) {
			this.form.patchValue({ companyName: this.companyName });
		}
	}

	addCustomer() {
		if (this.form.valid) {
			const customer = {
				id: 0,
				companyName: this.form.value.companyName,
				billingEmail: this.form.value.billingEmail,
				address: this.form.value.address || {},
			};
			this.customerClient
				.saveCustomer(customer)
				.pipe(
					exhaustMap((id) => this.customerClient.getCustomerLink(id))
				)
				.subscribe((customerLink) =>
					this.addCustomerDialogComponent.close(customerLink)
				);
		}
	}
}
